import * as Form from '../../../components/form'
export * from '../constants'

export const FETCH_OTHER_CLICKS = 'FETCH_OTHER_CLICKS'
export const OTHER_CLICKS_FILTER = 'OTHER_CLICKS_FILTER'
export const NUM_OTHER_CLICKS = 25

export const FormConstants = Form.createConstantsMap(OTHER_CLICKS_FILTER)



// WEBPACK FOOTER //
// ./src/pages/reports/other-clicks/constants.ts